import React from 'react';
import PropTypes from 'prop-types';
import { Map, List, OrderedSet } from 'immutable';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getEnumsForFormSelect } from '../../../reducer';
import { Field, MuiSelect, MuiTextField } from '../../../common/form';

const EnumPlaceholderInputView = ({ name, choices }) => <MuiSelect options={choices} name={name} variant="outlined" margin="dense" />;
EnumPlaceholderInputView.propTypes = {
  name: PropTypes.string.isRequired,
  choices: PropTypes.oneOfType([PropTypes.instanceOf(OrderedSet), PropTypes.instanceOf(List)]).isRequired,
};

const EnumPlaceholderInput = connect((state, { enumId }) => ({
  choices: getEnumsForFormSelect(state, enumId),
}))(EnumPlaceholderInputView);

const PlaceholderInput = ({ name, placeholder }) => {
  switch (placeholder.get('type')) {
    case 'dropdown':
      return <EnumPlaceholderInput name={name} enumId={placeholder.get('enumId')} />;
    case 'number':
      return <Field name={name} component={MuiTextField} size="small" variant="outlined" required type="number" />;
    case 'free-text':
      return <Field name={name} component={MuiTextField} size="small" variant="outlined" required />;
    default:
      return <Field name={name} component={MuiTextField} size="small" variant="outlined" required />;
  }
};
PlaceholderInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.instanceOf(Map).isRequired,
};

const PlaceholderTypesMeta = ({ placeholder, name }) => (
  <Field
    name={name}
    component={({ input: { value, onChange } }) => {
      if (value !== placeholder.get('type')) {
        onChange(placeholder.get('type'));
      }
      return null;
    }}
  />
);
PlaceholderTypesMeta.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.instanceOf(Map).isRequired,
};

const InlineInputStyles = styled.div`
  display: inline-block;
  vertical-align: bottom;
  margin-bottom: -12px;

  button {
    margin: 0 10px;
  }

  & > div {
    margin: 5px 5px !important;

    & > div {
      height: 2em;
      width: calc(100% - 10px) !important;
    }
  }
`;

const injectField = (str, key, placeholder, namespace) => {
  const offset = str.indexOf(key);
  if (offset < 0) {
    return str;
  }
  return [
    str.slice(0, offset),
    <InlineInputStyles key={key}>
      <PlaceholderInput placeholder={placeholder} name={`${namespace}.${key}`} />
    </InlineInputStyles>,
    <PlaceholderTypesMeta key={`${key}_type`} placeholder={placeholder} name={`${namespace}_type.${key}`} />,
    str.slice(offset + key.length),
  ];
};

const QuestionTemplateCustomizer = ({ namespace, question, placeholders }) => {
  if (placeholders.isEmpty()) {
    return question;
  }
  return placeholders.reduce(
    (reduction, value, key) => {
      const converted = reduction.map((segment) => {
        if (typeof segment === 'string') {
          return injectField(segment, key, value, namespace);
        }
        return segment;
      });
      return [].concat(...converted);
    },
    [question],
  );
};
QuestionTemplateCustomizer.propTypes = {
  namespace: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  placeholders: PropTypes.instanceOf(Map),
};
QuestionTemplateCustomizer.defaultProps = {
  placeholders: Map(),
};

export default QuestionTemplateCustomizer;
